import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
const ls = new SecureLS({ isCompression: false });

export default new Vuex.Store({
  state: {
    cart: [],
    favorite: [],
    userData: [],
  },
  mutations: {
    SET_CART: (state, product) => {
      if (state.cart.length) {
        let isProduct = false
        state.cart.map((item) => {
          if (item.id === product.id) {
            isProduct = true
            item.quantity++
            item.price = item.quantity * item.oldprice
          }
        })
        if (!isProduct) {
          state.cart.push(product)
        }
      } else {
        state.cart.push(product)
      }
    },
    REMOVE_FROM_CART: (state, index) => {
      state.cart.splice(index, 1)
    },
    DECREMENT: (state, index) => {
      if (state.cart[index].quantity > 1) {
        state.cart[index].quantity--
        state.cart[index].price = state.cart[index].price - state.cart[index].oldprice
      }
    },
    INCREMENT: (state, index) => {
      state.cart[index].quantity++
      state.cart[index].price = state.cart[index].quantity * state.cart[index].oldprice
    },
    SET_FAVORITE: (state, product) => {
      if (state.favorite.length) {
        let isProduct = false
        state.favorite.map((item) => {
          if (item.id === product.id) {
            isProduct = true
          }
        })
        if (!isProduct) {
          state.favorite.push(product)
        }
      } else {
        state.favorite.push(product)
      }
    },
    REMOVE_FROM_FAVORITE: (state, index) => {
      state.favorite.splice(index, 1)
    },
    ADD_USER: (state, user) => {
      state.userData.push(user)
    },
    SIGN_OUT: (state, user) => {
      state.userData = user
    },
  },
  actions: {
    ADD_TO_CART({commit}, product) {
      commit('SET_CART', product)
    },
    DELETE_FROM_CART({commit}, index) {
      commit('REMOVE_FROM_CART', index)
    },
    DECREMENT_PRICE({commit}, index) {
      commit('DECREMENT', index)
    },
    INCREMENT_PRICE({commit}, index) {
      commit('INCREMENT', index)
    },
    ADD_TO_FAVORITE({commit}, product) {
      commit('SET_FAVORITE', product)
    },
    DELETE_FROM_FAVORITE({commit}, index) {
      commit('REMOVE_FROM_FAVORITE', index)
    },
    ADD_USER_DATA({commit}, user) {
      commit('ADD_USER', user)
    },
    SIGN_OUT_USER({commit}, user) {
      commit('SIGN_OUT', user)
    }
  },
  modules: {
  },
  getters: {
    CART(state) {
      return state.cart
    },
    FAVORITE(state) {
      return state.favorite
    },
    USER(state) {
      return state.userData
    }
  },
  plugins: [createPersistedState({
    storage: {
      getItem: key => ls.get(key),
      setItem: (key, value) => ls.set(key, value),
      removeItem: key => ls.remove(key)
    }
  })],
})
